<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      label-width="110px"
      :model="formInline"
      :rules="formInlineRules"
      v-show="isShowSearch"
      class="user-search"
    >
      <!-- <el-row :gutter="10"> -->
      <!-- <el-col :sm="8" :lg="5" :xl="5"> -->
      <div class="search_formul">
        <div class="search_formli">
          <el-form-item label="商品名称">
            <el-input
              size="small"
              clearable
              v-model="formInline.name"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
        </div>
        <div class="search_formli">
          <el-form-item label="品牌" prop="brand">
            <el-select
              size="small"
              filterable
              class="full_select"
              v-model="formInline.brand"
              placeholder="请选择品牌"
            >
              <el-option
                v-for="item in brandOptions"
                :key="item.id + '-ppkey'"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- </el-col> -->
        <!-- <el-col :sm="8" :lg="6" :xl="6"> -->
        <div class="search_formli">
          <el-form-item label="商品类型">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.source"
              placeholder="请选择商品类型"
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.id + '-smlxkey'"
                :label="item.key"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="search_formli">
          <!-- </el-col> -->
          <!-- <el-col :sm="8" :lg="6" :xl="6"> -->
          <el-form-item label="商品来源">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.flag"
              placeholder="请选择商品来源"
            >
              <el-option
                v-for="item in productSource"
                :key="item.value + '-splykey'"
                :label="item.key"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
        </div>
        <div class="search_formli">
          <el-form-item label="本地商品来源">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.productSource"
              placeholder="请选择本地商品来源"
            >
              <el-option
                v-for="item in productSourceOpts"
                :key="item.id + '-splykey'"
                :label="item.key"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

      </div>
      <div class="search_formul">
        <div class="search_formli">
          <!-- <el-col :sm="8" :lg="6" :xl="6"> -->

          <el-form-item label="产品分类">
            <treeselect
              v-model="formInline.classificationId"
              :options="classOptions"
              :normalizer="normalizer"
              :show-count="true"
              placeholder="请选择产品分类"
            />
          </el-form-item>
          <!-- </el-col> -->
        </div>
        <div class="search_formli">
          <!-- <el-col :sm="8" :lg="6" :xl="6"> -->
          <el-form-item label="是否推荐">
            <el-select
              size="small"
              clearable
              v-model="formInline.isRecommend"
              placeholder="请选择商品是否推荐"
            >
              <el-option
                v-for="item in isRecommendOptions"
                :key="item.value + '-isrecmkey'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
        </div>
        <div class="search_formli">
          <!-- <el-col :sm="8" :lg="6" :xl="6"> -->
          <el-form-item label="是否上架">
            <el-select
              size="small"
              clearable
              v-model="formInline.underCarriage"
              placeholder="请选择商品是否上架"
            >
              <el-option
                v-for="item in underCarriages"
                :key="item.value + '-carrkey'"
                :label="item.key"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
        </div>

        <div class="search_formli">
          <!-- <el-col :sm="8" :lg="24" :xl="24"> -->
          <el-form-item label="所属国家">
            <el-select
              size="small"
              filterable
              clearable
              v-model="formInline.nationalId"
              placeholder="请选择所属国家"
            >
              <el-option
                v-for="item in nationalOptions"
                :key="item.id + '-natkey'"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
        </div>
        <div class="search_formli">
          <el-form-item label="库存范围">
            <el-select
              size="small"
              clearable
              filterable
              v-model="formInline.inventory"
              placeholder="请选择库存范围"
            >
              <el-option
                v-for="item in inventoryOption"
                :key="item.id + '-inventory'"
                :label="item.key"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="search_formul">
        <div class="search_formli start_money">
          <!-- <el-col :sm="8" :lg="12" :xl="12"> -->
          <el-form-item label="开始价格" prop="startAmount">
            <el-input-number
              size="small"
              :precision="2"
              clearable
              class="full_select"
              v-model="formInline.startAmount"
              placeholder="请输入开始价格(元)"
            ></el-input-number>
          </el-form-item>

          <!-- </el-col> -->
        </div>
        <div class="search_formli end_money">
          <el-form-item label="结束价格" prop="endAmount">
            <el-input-number
              size="small"
              :precision="2"
              class="full_select"
              clearable
              v-model="formInline.endAmount"
              placeholder="请输入结束价格(元)"
            ></el-input-number>
          </el-form-item>
        </div>

        <div class="search_formli">
          <!-- <el-col :sm="8" :lg="6" :xl="6"> -->
          <el-form-item label="同步积分商城">
            <el-select
              size="small"
              clearable
              v-model="formInline.isPointsMall"
              placeholder="请选择商品是否同步积分商城"
            >
              <el-option
                v-for="item in pointsOpts"
                :key="item.value + '-isMall'"
                :label="item.key"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
        </div>
        <div class="search_formli btn_group">
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-search"
              @click="search"
            >搜索
            </el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-refresh"
              @click="resetFormLine"
            >清空
            </el-button
            >
          </el-form-item>
        </div>
      </div>
      <!-- <el-col :sm="24" :lg="6" :xl="6">
        <el-form-item label="结束商品价格" prop="endAmount">
          <el-input-number
            size="small"
            :precision="2"
            class="full_select"
            clearable
            v-model="formInline.endAmount"
            placeholder="请输入结束商品价格(元)"
          ></el-input-number>
        </el-form-item>
      </el-col> -->
      <!-- <div class="search_formli"> -->

      <!-- </div> -->
      <!-- <el-col :span="24"> -->

      <!-- </el-col> -->
      <!-- </el-row> -->

    </el-form>
    <el-row>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="handleEdit()"
      >添加商品
      </el-button
      >
      <el-button
        size="small"
        type="success"
        plain
        :disabled="isGroundingBtn"
        icon="el-icon-top"
        @click="batchUnderCarriage(1,'上架')"
      >批量上架
      </el-button>
      <el-button
        size="small"
        type="warning"
        plain
        :disabled="isGroundingBtn"
        icon="el-icon-bottom"
        @click="batchUnderCarriage(0,'下架')"
      >批量下架
      </el-button
      >
      <el-button size="small" type="success" plain icon="el-icon-download" @click="importLeader">导入</el-button>
      <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>
<!--      <el-button-->
<!--        size="small"-->
<!--        type="info"-->
<!--        plain-->
<!--        :disabled="isGroundingBtn"-->
<!--        @click="batchExport"-->
<!--        icon="el-icon-top"-->
<!--      >批量导出-->
<!--      </el-button>-->
      <el-button
        size="small"
        type="info"
        plain
        :disabled="isGroundingBtn"
        @click="handleIntegral"
        icon="el-icon-refresh"
      >批量同步到积分商城
      </el-button>
    </el-row>
    <div class="hide_search_box">
      <el-tooltip class="hide_search" effect="dark" :content="!isShowSearch?'显示搜索':'隐藏搜索'" placement="top-start">
        <el-button icon="el-icon-search" size="small"
                   type="primary"
                   plain
                   @click="hideSearch" circle></el-button>
      </el-tooltip>
    </div>
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      @selection-change="selectChange"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column label="主键" prop="id" align="center"  width="80">
      </el-table-column>
      <el-table-column
        label="商品来源"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template slot-scope="scope">
          {{ getThirdFlag(scope.row.thirdFlag) }}
        </template>
      </el-table-column>
      <el-table-column label="本地商品来源"
                       align="center"
                       show-overflow-tooltip
                       width="150"
        prop="productSource">
        <template slot-scope="scope">
          {{ getDictKeyById(productSourceOpts, scope.row.productSource, "key") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        align="center"
        min-width="200"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="thirdGoodId"
        label="商品ID"
        min-width="200"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="商品条形码"
        min-width="200"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div class="imgarea flex-view justify align" v-if="scope.row.barCodeImageUrlOss != null">
            <el-image
              class="table-img"
              style="width: 100px; height: 40px"
              :src="scope.row.barCodeImageUrlOss"
              :preview-src-list="[`${scope.row.barCodeImageUrlOss}`]"
            >
            </el-image>
            <div class="btn-img-down" @click="barCodeDown(scope.row.barCodeImageUrlOss,scope.row.thirdGoodId)">
              下载
            </div>
          </div>
          <div v-else>
            暂无条形码
          </div>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="brand"
        label="品牌"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{ getDictKeyById(brandOptions, scope.row.brand, "key") }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="interAmount"
        label="成本价格"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="amount"
        label="商品价格"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="vipAmount"
        label="会员价格"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column label="产品分类" prop="classificationName" show-overflow-tooltip align="center">
<!--        <template slot-scope="scope">-->
<!--          {{-->
<!--            backShowClass(-->
<!--              scope.row.classificationId-->
<!--            )-->
<!--          }}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column align="center" min-width="120px" label="接口商品类型">
        <template slot-scope="scope">
          {{ typeNameList[scope.row.interGoodType * 1] }}
        </template>
      </el-table-column>
      <el-table-column label="生产厂家" align="center">
        <template slot-scope="scope">
          {{ getDictKeyById(factorOptions, scope.row.manufactor, "key") }}
        </template>
      </el-table-column>
      <el-table-column label="产品标签" align="center">
        <template slot-scope="scope">
          <el-tag
            style="marginright: 10px; marginbottom: 10px"
            size="mini"
            v-if="scope.row.flagList != null"
            v-for="id in scope.row.flagList"
            :key="id+'cpbq'"
          >
            {{ getDictKeyById(flagOptions, id, "key") }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="产品图片" min-width="200">
        <template slot-scope="scope">
          <div class="imgarea">
            <el-image
              class="table-img"
              v-for="imgoss in scope.row.detailImageOss"
              :key="imgoss"
              style="width: 36px; height: 24px"
              :src="imgoss"
              :preview-src-list="[imgoss]"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否推荐" min-width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecommend"
            @change="recommendChange($event, scope.row)"
            :active-value="0"
            size="mini"
            :inactive-value="1"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否上架" min-width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.underCarriage"
            @change="underCarriageChange($event, scope.row)"
            :active-value="1"
            size="mini"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否已同步积分商城" min-width="180" align="center">
        <template slot-scope="scope">
<!--          active-text="已同步"-->
<!--          inactive-text="未同步"-->
          <el-switch
            v-model="scope.row.isPointsMall"
            @change="pointsMallChange($event, scope.row)"

            :active-value="1"
            size="mini"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="商品类型">
        <template slot-scope="scope">
          {{ getDictKeyById(sourceOptions, scope.row.source, "key") }}
        </template>
      </el-table-column>

      <el-table-column prop="nationalName" label="所属国家"></el-table-column>
      <el-table-column prop="surplusNum" label="库存数量"></el-table-column>
      <el-table-column prop="virtuallySalesNum" label="虚拟销量"></el-table-column>
      <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.createDate | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="修改时间" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.updateDate | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <div class="flex-view">
            <div class="fl-1 btn-area">
              <el-button size="mini" @click="handleEdit(999, scope.row)"
              >查看
              </el-button>
            </div>
            <div class="fl-1 btn-area">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row, '')"
              >编辑
              </el-button>

            </div>
            <div class="fl-1 btn-area">
              <el-button size="mini" @click="createBarcodeFun( scope.row)"
              >生成条码
              </el-button>
            </div>
<!--            <div class="fl-1 btn-area">-->
<!--              <el-button size="mini" @click="handleIntegral(scope.row)"-->
<!--              >同步到积分商城-->
<!--              </el-button>-->
<!--            </div>-->
            <div class="fl-1 btn-area">
              <el-button
                size="mini"
                type="danger"
                @click="deleteProduct(scope.$index, scope.row)"
              >删除
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-drawer
      :title="title"
      :visible.sync="editFormVisible"
      size="70%"
      :wrapperClosable="false"
      @close="closeDialog('editForm')"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        ref="editForm"
        :rules="rules"
        :disabled="disabled"
      >
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品名称" prop="name">
              <el-input
                size="small"
                v-model="editForm.name"
                auto-complete="off"
                placeholder="请输入商品名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品价格" prop="amount" v-if="title == '查看'">
              <el-input-number
                size="small"
                :precision="2"
                style="width: 100%"
                clearable
                v-model="editForm.amount"
                placeholder="请输入商品价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品总数量" prop="totalNum" v-if="title == '查看'">
              <el-input
                size="small"
                @input="
                  editForm.totalNum = editForm.totalNum.replace(
                    /^(0+)|[^\d]+/g,
                    ''
                  )
                "
                clearable
                v-model="editForm.totalNum"
                placeholder="请输入产品总数量"
              >
                <template #append>
                  <span>件</span>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="会员价格" prop="vipAmount" v-if="title == '查看'">
              <el-input-number
                size="small"
                style="width: 100%"
                :precision="2"
                clearable
                v-model="editForm.vipAmount"
                placeholder="请输入会员价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品分类" prop="classificationId">
              <treeselect
                v-model="editForm.classificationId"
                :options="classOptions"
                :normalizer="normalizer"
                :show-count="true"
                :disabled="disabled"
                placeholder="请选择产品分类"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="产品标签" prop="flagList">
              <el-select
                size="small"
                class="full_select"
                multiple
                clearable
                filterable
                v-model="editForm.flagList"
                placeholder="请选择产品标签"
              >
                <el-option
                  v-for="item in flagOptions"
                  :key="item.id + '-flagkey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="商品类型" prop="source">
              <el-select
                size="small"
                class="full_select"
                clearable
                filterable
                v-model="editForm.source"
                placeholder="请选择商品类型"
              >
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.id + '-seltypekey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="生产厂家" prop="manufactor">
              <el-select
                size="small"
                class="full_select"
                clearable
                filterable
                v-model="editForm.manufactor"
                placeholder="请选择生产厂家"
              >
                <el-option
                  v-for="item in factorOptions"
                  :key="item.id + '-fackey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :lg="12" :xs="24">
            <el-form-item label="所属国家" prop="nationalId">
              <el-select
                size="small"
                class="full_select"
                filterable
                v-model="editForm.nationalId"
                placeholder="请选择所属国家"
              >
                <el-option
                  v-for="item in nationalOptions"
                  :key="item.id + '-selnationkey'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xs="24">
            <el-form-item label="品牌" prop="brand">
              <el-select
                size="small"
                filterable
                class="full_select"
                v-model="editForm.brand"
                placeholder="请选择品牌"
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id + '-ppkey'"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="成本价格" prop="interAmount"   v-if="title == '查看'">
              <el-input-number
                size="small"
                :precision="2"
                style="width: 100%"
                clearable
                :disabled="title == '查看'|| title == '编辑'"
                v-model="editForm.interAmount"
                placeholder="请输入成本价格(元)"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="利润类型" prop="profitType">
              <el-select
                size="small"
                filterable
                class="full_select"
                v-model="editForm.profitType"
                placeholder="请选择利润类型"
              >
                <el-option
                  v-for="item in profitOptions"
                  :key="item.id + '-lrkey'"
                  :label="item.value"
                  :value="Number(item.key)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="本地商品来源" prop="productSource">
              <el-select
                size="small"
                clearable
                filterable
                style="width: 100%"
                v-model="editForm.productSource"
                placeholder="请选择本地商品来源"
              >
                <el-option
                  v-for="item in productSourceOpts"
                  :key="item.id + '-splykey'"
                  :label="item.key"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="虚拟销量" prop="virtuallySalesNum" >
              <el-input-number
                size="small"
                style="width: 100%"
                clearable
                v-model="editForm.virtuallySalesNum"
                placeholder="请输入虚拟销量"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="产品图片" prop="detailImage">
              <el-upload
                :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
                ref="detailImageUpload"
                action="#"
                list-type="picture-card"
                :file-list="fileList"
                :limit="limitCountImg"
                :before-upload="beforeAvatarUpload"

                :http-request="uploadArrBinary"
              >
<!--                :on-change="swiperImgChange"-->
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="img_size_tip">
                  避免影响小程序内显示效果，请上传：1/1比例图片
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt=""/>
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="title=='查看'">
            <el-form-item label="商品条形码" prop="barCodeImageUrlOss">
              <div class="imgarea" v-if="editForm.barCodeImageUrlOss !=null">
                <el-image
                  class="table-img"
                  style="width: 200px; height: 80px"
                  :src="editForm.barCodeImageUrlOss"
                  :preview-src-list="[`${editForm.barCodeImageUrlOss}`]"
                >
                </el-image>

              </div>
              <div v-else style="height: 80px;line-height: 80px">
                暂无条形码
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <div>
            <div class="label-m" style="width: 120px">
              商品规格
            </div>
            <div>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-plus"
                @click="addProductSize"
              >添加规格
              </el-button
              >
            </div>
          </div>

          <div class="flex-view size-list">
            <div class="flex-item" v-for="(item,index) in editForm.productItemList">
              <el-form-item label="规格件装" :prop="`productItemList[${index}].specNum`" :rules="{ required: true, message: '请输入规格件装'}">
                <el-input-number
                  size="small"
                  style="width: 100%"
                  clearable
                  v-model="item.specNum"
                  placeholder="请输入规格件装"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="规格件装名称" :prop="`productItemList[${index}].specName`" :rules="{ required: true, message: '请输入规格件装名称'}">
                <el-input
                  size="small"
                  v-model="item.specName"
                  auto-complete="off"
                  placeholder="请输入规格件装名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="成本价" :prop="`productItemList[${index}].priceMarket`" :rules="{ required: true, message: '请输入成本价'}">
                <el-input
                  size="small"
                  v-model="item.priceMarket"
                  auto-complete="off"
                  placeholder="请输入成本价"
                ></el-input>
              </el-form-item>
              <el-form-item label="会员价" :prop="`productItemList[${index}].priceVip`" :rules="{ required: true, message: '请输入会员价'}">
                <el-input
                  size="small"
                  v-model="item.priceVip"
                  auto-complete="off"
                  placeholder="请输入会员价"
                ></el-input>
              </el-form-item>
              <el-form-item label="售价" :prop="`productItemList[${index}].priceSettlement`" :rules="{ required: true, message: '请输入售价'}">
                <el-input
                  size="small"
                  v-model="item.priceSettlement"
                  auto-complete="off"
                  placeholder="请输入售价"
                ></el-input>
              </el-form-item>
              <el-form-item label="库存"  :prop="`productItemList[${index}].stock`" :rules="{ required: true, message: '请输入库存'}">
                <el-input
                  size="small"
                  v-model="item.stock"
                  auto-complete="off"
                  placeholder="请输入库存"
                ></el-input>
              </el-form-item>
              <el-form-item label="毛重(千克)"  :prop="`productItemList[${index}].weight`" >
<!--                :rules="{ required: true, message: '请输入毛重(千克)'}"-->
                <el-input
                  size="small"
                  v-model="item.weight"
                  auto-complete="off"
                  placeholder="请输入毛重(千克)"
                ></el-input>
              </el-form-item>
              <el-form-item label="兑换积分" :prop="`productItemList[${index}].redemptionPoints`" :rules="{ required: false, message: '请输入兑换积分'}">
                <el-input
                  size="small"
                  v-model="item.redemptionPoints"
                  auto-complete="off"
                  placeholder="请输入兑换积分"
                ></el-input>
              </el-form-item>
              <el-form-item label="兑换价格"  :prop="`productItemList[${index}].exchangePrice`" :rules="{ required: false, message: '请输入兑换价格'}">
                <el-input
                  size="small"
                  v-model="item.exchangePrice"
                  auto-complete="off"
                  placeholder="请输入兑换价格"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否限购" :prop="`productItemList[${index}].enableLimitPurchase`">
                <el-switch
                  v-model="item.enableLimitPurchase"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  active-text="是"
                  inactive-text="否"
                />
              </el-form-item>
              <el-form-item v-if="item.enableLimitPurchase==1" label="限购数额" :prop="`productItemList[${index}].limitPurchaseNum`" :rules="{ required: true, message: '请输入限购数额'}">
                <el-input-number
                  size="small"
                  style="width: 100%"
                  clearable
                  v-model="item.limitPurchaseNum"
                  placeholder="请输入限购数额"
                ></el-input-number>
              </el-form-item>
              <div class="btn-del-area">
                <el-button
                  size="mini"
                  type="danger"
                  @click="delItemSize(index)"
                >删除规格
                </el-button>
              </div>
            </div>
          </div>
        </el-row>
        <el-row :gutter="10">
          <el-row>
            <el-col :span="12">
              <el-form-item label="简介" prop="adaptationDisease">
                <el-input
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="editForm.adaptationDisease"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <local-quill-editor :content="editForm.description" :isdisabled="!!disabled" @editChange="editChange"></local-quill-editor> -->
          <el-col :span="24">
            <el-form-item label="商品描述" prop="description">
              <editor v-model="editForm.description" :min-height="192"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="dr-footer"
        style="text-align: center"
        v-if="disabled == false"
      >
        <el-button size="small" @click="closeDialog('editForm')"
        >取消
        </el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
        >保存
        </el-button
        >
      </div>
    </el-drawer>
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url + '?updateSupport=' + upload.updateSupport"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :on-error="handleFileError"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <div class="el-upload__tip" slot="tip">
            <el-checkbox v-model="upload.updateSupport"/>
            是否更新已经存在的数据
          </div>
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                   @click="importTemplate">下载模板
          </el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GoodsList,
  GoodsSave,
  GoodsDelete,
  GoodsEdit,
  GoodsRecommend,
  underCarriage,
  setRecommend,
  getClassiFicationTypeList,
  getRoleList,
  // exportProduct,
  synToIntegral, classiFicationList, delVipProduct
} from "../../api/basisMG";
// import { getDictByTypeId } from '@/api/system'
import {createBarcode} from "@/api/productApi";
import {upimg} from "@/api/userMG";
import {Loading} from 'element-ui'
import Pagination from "../../components/Pagination";
import {getDictByTypeId, importTemplate, exportProduct} from "@/api/system";
import exportFile from '@/utils/exportFile'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {gatherOptions} from "../../api/system";
export default {
  data() {
    return {
      disabled: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      noneBtnImg: false, //图片按钮显示隐藏
      showBtnDealImg: true,
      isShowSearch: true,
      limitCountImg: 4,
      dialogImageUrl: "",
      detailImageArr: [],
      typeNameList: ['一般贸易', '保税', '海外直邮'],
      fileList: [],
      dialogVisible: false,
      sourceOptions: [],
      factorOptions: [],
      flagOptions: [],
      nationalOptions: [],
      proTypeListOption: [],
      brandOptions: [],
      profitOptions: [],
      isRecommendOptions: [
        {label: "是", value: 0},
        {label: "否", value: 1},
      ],
      productSource:[],
      underCarriages: [
        {key: "是", value: 1},
        {key: "否", value: 0},
      ],
      nationalImageUrl: "",
      coverImageUrl: "",
      detailImage: "",
      uploadheaders: {
        Authorization: localStorage.getItem("logintoken"),
      },
      rules: {
        name: [
          {required: true, message: "请输入商品名称", trigger: "blur"},
          {whitespace: true, message: "只存在空格", trigger: "blur"},
        ],
        amount: [
          {required: true, message: "请输入商品价格", trigger: "blur"},
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        interAmount: [
          {required: true, message: "请输入成本价格", trigger: "blur"},
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        totalNum: [
          {required: true, message: "请输入产品总数量", trigger: "blur"},
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        vipAmount: [
          {required: true, message: "请输入会员价格", trigger: "blur"},
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        classificationId: [
          {required: true, message: "请选择产品分类", trigger: "change"},
        ],
        // flagList:[ { required: true, message: '请选择产品标签', trigger: 'blur' },],
        source: [
          {required: true, message: "请选择商品类型", trigger: "change"},
        ],

        // manufactor:[ {required: true, message: '请选择生产厂家', trigger: 'change'} ],
        description: [
          {required: true, message: "请输入药品描述", trigger: "blur"},
        ],
        brand: [{required: true, message: "请选择品牌", trigger: "change"}],
        profitType: [{required: true, message: "请选择利润类型", trigger: "blur"}],
        imageUrlOss: [
          {required: true, message: "请添加推荐封面图片", trigger: "change"},
        ],
        // adaptationDisease:[ { required: true, message: '请输入药品适应症', trigger: 'blur' },],
        nationalId: [
          {required: true, message: "请选择所属国家", trigger: "change"},
        ],
        detailImage: [
          {required: true, message: "请添加商品详情图片", trigger: "change"},
        ],
        virtuallySalesNum:[ {required: true, message: "请输入虚拟销量", trigger: ["change","blur"]},]
      },
      formInlineRules: {
        startAmount: [
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        endAmount: [
          {
            type: "number",
            min: 0,
            max: 99999,
            message: `请输入5位数之内正数`,
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      editForm: {
        name: "",
        amount: "",
        totalNum: null,
        vipAmount: "",
        classificationId: undefined,
        flagList: "",
        source: "",
        manufactor: "",
        description: "",
        brand: "",
        imageUrlOss: "",
        adaptationDisease: "",
        nationalId: "",
        detailImage: "",
        profitType:"",
      },
      formInline: {
        page: 1,
        limit: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      isGroundingBtn: true, //批量按钮禁用
      ids: '',
      upload: {
        // 是否显示弹出层（导入）
        open: false,
        // 弹出层标题（导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: false,
        // 设置上传的请求头部
        headers: {Authorization: localStorage.getItem('logintoken')},
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/product/importData"
      },
      inventoryOption:[
        {
          id:1,
          key:'小于50',
          val:0
        },
        {
          id:2,
          key:'50-100',
          val:1
        },
        {
          id:3,
          key:'大于100',
          val:2
        },
      ],
      classOptions:[],
      pointsOpts:[
        {
          key:'已同步',
          value:1
        },
        {
          key:'未同步',
          value:0
        }
      ],
      fullscreenLoading: false,//全屏loading
      tsetData:'',
      productSourceOpts:[]
    };
  },
  watch: {
    'editForm.detailImage'(newVal) {
      console.log('detailImage 更新:', newVal);
      // 可以在这里进行额外的处理，例如日志记录或调试
    }
  },
  // 注册组件
  components: {
    Pagination,
    // LocalQuillEditor
    Treeselect
  },
  created() {
    this.getdata(this.formInline);
    this.getDictByTypeId();
    this.getClassiFication()
    this.getDict()
  },
  methods: {
    getClassiFication() {
      classiFicationList().then((res) => {
        this.proTypeListOption = res.body; // 获取分类下拉列表
        this.classOptions = res.body;
        // let menu = { 'id': 0, 'name': '主类目', children: [] };
        // menu.children = res.body;
        // console.log(menu)
        // this.classOptions.push(menu);
      });
    },
    //获取字典数据
    getDict() {
      this.getDictById(32)
    },
    async getDictById(id) {
       const {body} =  await getDictByTypeId(id)
        this.productSource = body
    },
    // 展示隐藏搜索
    hideSearch() {
      this.isShowSearch = !this.isShowSearch
    },
    // selection选择
    selectChange(selection) {
      // console.log('selection',selection);
      if (selection.length > 0) {
        this.isGroundingBtn = false
      } else {
        this.isGroundingBtn = true
      }
      let ids;
      ids = selection.map(item => item.id)
      this.ids = ids.join()
    },
    // 批量上下架
    batchUnderCarriage(typeValue, typeName) {
      this.loading = true
      let par = {
        underCarriage: typeValue, // 1上架
        ids: this.ids,
      };
      underCarriage(par).then(res => {
        if (res.rsp_code == 200) {
          // this.$message.success(typeName+'成功！')
          const h = this.$createElement;
          this.$message.success({
            message: h('p', null, [
              h('i', {style: 'color: teal'}, res.body)
            ]),
            duration: 4000,
          })
          this.getdata(this.formInline);
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    // 批量导出
    batchExport(fileName) {
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      exportProduct({ids: this.ids}).then(res => {
        exportFile.getExcel(res, `product_list_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    resetForm() {
      // this.$nextTick(() => {
      //   this.$refs['editForm'].clearValidate();
      //   this.$refs['editForm'].resetFields()
      // });
      this.detailImageArr = []; //清除保存图片No的数组缓存 避免连续上传重复
      this.editForm = {
        name: "",
        amount: "",
        totalNum: null,
        vipAmount: "",
        classificationId: undefined,
        flagList: "",
        source: "",
        manufactor: "",
        description: "",
        brand: "",
        imageUrlOss: "",
        adaptationDisease: "",
        nationalId: "",
        detailImage: "",
        productItemList: [],
        productSource: "" // 添加 productSource 字段
      };
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs['editForm']) {
          this.$refs['editForm'].clearValidate();
        }
      });
    },
    resetFormLine() {
      this.formInline = {
        page: 1,
        limit: 10,
      };
    },
    changes(value) {
      // if(value > this.max) {
      this.editForm.vipAmount = value;
      // }
    },
    // 轮播图自定义上传
    uploadArrBinary(filePath) {
      console.log(32132)
      let that = this;
      let formData = new FormData();
      formData.append("file", filePath.file);
      upimg(formData).then((res) => {
        that.detailImageArr.push(res.body.imageNo);
        that.editForm.detailImage = this.detailImageArr.join(";");
        // 手动触发表单验证
        // this.$nextTick(() => {
        //   this.$refs['editForm'].validateField('detailImage');
        // });
      });
    },

    handleRemove(file) {
      console.log(32132)
      let that = this;
      const index = this.fileList.findIndex((e) => e.uid === file.uid);
      this.fileList.splice(index, 1);
      this.noneBtnImg = this.fileList.length >= this.limitCountImg; //添加按钮显隐
      // 删除的时候把this.editForm.detailImage 对应的imgNo删掉
      that.detailImageArr.splice(index, 1);
      that.editForm.detailImage = this.detailImageArr.join(";");
      // 手动触发表单验证
      // this.$nextTick(() => {
      //   this.$refs['editForm'].validateField('detailImage');
      // });
    },
    // 多图预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    swiperImgChange(file, fileList) {
      console.log(32132)
      this.fileList = fileList;
      this.noneBtnImg = fileList.length >= this.limitCountImg;
      // 更新 detailImage 字段并重新验证
      this.editForm.detailImage = this.detailImageArr.join(";");
      // 手动触发表单验证
      // this.$nextTick(() => {
      //   this.$refs['editForm'].validateField('detailImage');
      // });
    },
    beforeAvatarUpload(file) {
      // console.log(file,'图片文件before');
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("只能上传jpg或png格式!");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
      // return isLt2M;
    },
    // 富文本内容
    editChange(e) {
      // console.log(e,'富文本change时的值');
      this.editForm.description = e.html;
    },
    // 获取列表
    getdata(parameter) {
      this.loading = true;
      /***
       * 调用接口
       */
      GoodsList(parameter)
        .then((res) => {
          this.loading = false;
          if (res.rsp_code !== 200) {
            this.$message({
              type: "info",
              message: res.rsp_msg,
            });
          } else {
            this.listData = res.body.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page;
            this.pageparm.pageSize = this.formInline.limit;
            this.pageparm.total = res.body.total;
          }
        })
        .catch((err) => {
          callFather;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row, typeName) {
      this.editFormVisible = true;
      this.disabled = false;
      this.fileList = [];
      this.resetForm();
      if (index == 999) {
        this.title = "查看";
        this.disabled = true;
        this.editForm = row;
        for (
          let index = 0;
          index < this.editForm.detailImageOss.length;
          index++
        ) {
          this.fileList.push({url: this.editForm.detailImageOss[index]});
        }
        this.noneBtnImg = true;
      } else {
        if (row != undefined && row != "undefined") {
          this.title = "编辑";
          this.editForm = row;
          let imgArr = row.detailImage.split(";");
          for (
            let index = 0;
            index < this.editForm.detailImageOss.length;
            index++
          ) {
            this.fileList.push({url: this.editForm.detailImageOss[index]});
            this.detailImageArr.push(imgArr[index]);
          }
          this.noneBtnImg = this.fileList.length >= this.limitCountImg;
        } else {
          this.noneBtnImg = false;
          this.title = "添加";
          // this.editForm = {
          //   name: "",
          //   description: "",
          //   // listImgNoOss:'',nationalOss:'',imageUrlOss:'',
          //   detailImageOss: "",
          //   productItemList:[]
          // };
          this.fileList = [];
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(this.editForm.productItemList.length < 1) {
        return this.$message({
          type: "info",
          message: "请添加产品规格",
        });
      }
      console.log(this.editForm.detailImage)
      console.log(this.$refs[editData])
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let subType = this.title == "添加" ? GoodsSave : GoodsEdit;
          if (this.editForm.flagList && this.editForm.flagList.length > 0) {
            this.editForm.flag = this.editForm.flagList.join(";");
          }
          console.log(this.editForm)
          subType(this.editForm)
            .then((res) => {
              this.loading = false;
              if (res.rsp_code == 200) {
                this.getdata(this.formInline);
                this.editFormVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.rsp_msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          // return false
          this.moveToErr();
        }
      });
    },
    // 滑动到未
    moveToErr() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName("is-error");
        if (isError.length) {
          isError[0].scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          // 这个当滑动到报错项之后自动获取输入框的焦点，方便用户直接进行输入，延迟 800ms 是因为需要都能到定位成功后在进行获取焦点体验更好一些
          setTimeout(() => {
            if (isError[0].previousElementSibling.querySelector("input")) {
              isError[0].previousElementSibling.querySelector("input").focus();
            }
          }, 800);
        }
      });
    },
    // 设置推荐
    recommendChange($event, row) {
      let par = {
        recommend: $event,
        id: row.id,
      };
      if (row.underCarriage == 0) {
        this.$message.warning("未上架商品不能设置推荐！");
        row.isRecommend = 1;
        return;
      }
      let text = row.isRecommend == 0 ? "设为推荐" : "取消推荐";
      this.$confirm("确定要把" + '"' + row.name + '"' + text + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return GoodsRecommend(par);
        })
        .then((res) => {
          if (res.rsp_code == 200) {
            this.$message.success(text + "成功！");
            this.getdata(this.formInline);
          }
        })
        .catch(function () {
          row.isRecommend = row.isRecommend === 0 ? 1 : 0;
        });
    },
    // 上下架
    underCarriageChange($event, row) {
      let par = {
        underCarriage: $event,
        ids: row.id,
      };
      let text = row.underCarriage == 0 ? "下架" : "上架";
      this.$confirm("确定要把" + '"' + row.name + '"' + text + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return underCarriage(par);
        })
        .then(async (res) => {
          if (res.rsp_code == 200) {
            // this.$message.success(text + "成功！");
            const h = this.$createElement;
            this.$message.success({
              message: h('p', null, [
                h('i', {style: 'color: teal'}, res.body)
              ]),
              duration: 4000,
            })
            if (text == '下架') {
              await GoodsRecommend({id: row.id, recommend: 1})
            }
            await this.getdata(this.formInline);
          }
        })
        .catch(function () {
          row.underCarriage = row.underCarriage === 0 ? 1 : 0;
        });
    },
    // 获取药品来源字典
    getDictByTypeId() {
      getDictByTypeId(2).then((res) => {
        this.sourceOptions = res.body;
      });
      getDictByTypeId(8).then((res) => {
        this.flagOptions = res.body;
      });
      getDictByTypeId(10).then((res) => {
        this.factorOptions = res.body; //生产厂家
      });
      getDictByTypeId(11).then((res) => {
        this.brandOptions = res.body; //品牌
      });
      getDictByTypeId(19).then((res) => {
        this.profitOptions = res.body; //利润类型
      });
      //本地商品来源
      getDictByTypeId(33).then((res) => {
        this.productSourceOpts = res.body; //利润类型
      });

      // getClassiFicationTypeList().then((res) => {
      //   this.proTypeListOption = res.body; // 获取分类下拉列表
      // });
      getRoleList().then((res) => {
        this.nationalOptions = res.body;
      });
    },
    pointsMallChange($event, row) {
      console.log($event)
      let text = row.isPointsMall == 0 ? "确定要从积分商城删除该商品吗？" : "确定要同步该商品到积分商城吗？";
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log(11)
        if(row.isPointsMall == 0) {
          this.deleteIntegral(row)
        }
        else {
          console.log(row.underCarriage)
          if (!row.underCarriage ) return row.isPointsMall = 0,this.$message({
            type: "info",
            message: "未上架商品不可同步到积分商城!",
          });

          this.handleIntegral(row)
        }
      }).catch(() => {
        console.log(22)
        row.isPointsMall == 0 ? row.isPointsMall = 1 : row.isPointsMall = 0
        });

    },
    // 同步到积分商城
    handleIntegral(row) {

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let ids = row.id || this.ids
      synToIntegral(ids).then(res => {
        loading.close();
        this.getdata(this.formInline);
        if (res.rsp_code == 200) {
          console.log(1111)
          if(row.id){
            this.$message({
              type: "success",
              message: "同步成功!",
            });
          }
          else {
            this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + '同步成功'+res.body.success+'件商品；'+'同步失败'+res.body.error+'件商品'+  "</div>", "同步结果", {dangerouslyUseHTMLString: true});
          }
        } else {

          this.$message({
            type: "info",
            message: res.rsp_msg,
          });
        }
      }).catch((err) => {
        loading.close();
        this.loading = false;
        this.$message.error("同步失败，请稍后再试！");
        this.getdata(this.formInline);
      });
    },
    //删除积分商城商品
    deleteIntegral(row) {
      let that = this;
      // console.log(that.ids)
      // let ids = row ?  row.id:that.ids;
      let ids = row.id || this.ids
      console.log(ids)
      delVipProduct(ids)
        .then((res) => {
          this.getdata(this.formInline);
          if (res.rsp_code == 200) {

            this.$message({
              type: "success",
              message: "删除成功!",
            });

          } else {
            this.$message({
              type: "info",
              message: res.rsp_msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("删除失败，请稍后再试！");
          this.getdata(this.formInline);
        });
      // this.$confirm("确定要删除积分商品吗?", "信息", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //
      //   }).catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消删除",
      //     });
      //   });
    },
    // 删除公司
    deleteProduct(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          GoodsDelete(row.id)
            .then((res) => {
              if (res.rsp_code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.rsp_msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.getdata(this.formInline);
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
    // 根据字典id获取字典key
    getDictKeyById(options, id, keyString) {
      let key = "";
      options.forEach((item) => {
        if (item.id * 1 == id * 1) {
          key = item[keyString];
        }
      });
      return key;
    },
    backShowClass(id) {
      console.log(id)
      // for (let item in this.classOptions) {
      //   if()
      // }
    },
    getThirdFlag(flag) {
      let text =null;

      if (flag != null) {
        let list = this.productSource.filter( item => item.id === flag)
        text = list[0].key
      }
      else {
        text = "私有";
      }
      // console.log(text)
      return text;
    },
    createBarcodeFun(row) {
      console.log(row)
      this.loading = true;
      createBarcode({id:row.id})
        .then((res) => {
          this.loading = false;
          if (res.rsp_code == 200) {
            this.getdata(this.formInline);
            this.$message.success({
              type: "info",
              message: '条形码生成成功',
            });
          }else if(res.rsp_code == 500) {

            this.$message({
              type: "success",
              message: '条形码生成失败',
            });
          }
          else {
            this.$message({
              type: "info",
              message: res.rsp_msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    barCodeDown(url,name) {
      console.log(url,name)
      exportFile.getImgURLs(url, name)
    },
    /** 导入按钮操作 */
    importLeader() {
      this.upload.title = "商品导入";
      this.upload.open = true;
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download('system/goods/export', {
      //   ...this.queryParams
      // }, `goods_${new Date().getTime()}.xlsx`)
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      exportProduct({ids: this.ids}).then(res => {
        exportFile.getExcel(res, `productList_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    // 下载模板
    importTemplate() {
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      importTemplate().then(res => {
        exportFile.getExcel(res, `productTemplate_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.rsp_msg + "</div>", "导入结果", {dangerouslyUseHTMLString: true});
      this.getdata(this.formInline)
    },
    handleFileError(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.rsp_msg + "</div>", "导入结果", {dangerouslyUseHTMLString: true});
      this.getdata(this.formInline)
    },
    addProductSize() {
      let item = {
        "specNum":"",
        "specName":"",
        "priceMarket":"",
        "priceVip":"",
        "priceSettlement":"",
        "stock":"",
        "redemptionPoints":"",
        "exchangePrice":"",
        "limitPurchaseNum": 0,
      }
      this.editForm.productItemList.push(item)
    },
    delItemSize(i) {
      this.editForm.productItemList.splice(i, 1)
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children
      };
    },
  },
};
</script>
<style>
.hide_search_box {
  position: relative;
  margin-top: 60px;
}

.hide_search {
  position: absolute;
  top: -50px;
  right: 20px;
}

.ql-container {
  height: 80%;
}

.el-form-item__content .el-input-group {
  vertical-align: middle;
}

.el-upload__tip {
  line-height: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

/* 上传按钮显示隐藏 */
.uoloadSty .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.disUoloadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}

.el-drawer__body {
  overflow-x: hidden;
  padding-right: 20px;
  padding-bottom: 60px;
}

.el-drawer__body::-webkit-scrollbar {
  height: 10px;
  width: 12px;
}

.el-drawer__body::-webkit-scrollbar-thumb {
  background: rgb(55, 88, 236);
}

.dr-footer {
  padding: 20px 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #ffffff;
}
</style>
<style scoped>
.table-img {
  margin: 0 5px;
}

::v-deep .el-dialog__body {
  padding-bottom: -1px;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
.flex-view{
  display: flex;
  flex-wrap:wrap
}
.justify{
  justify-content: center;
}
.align{
  align-items: center;
}
.btn-area{
  padding:0 10px 10px 0;
}
.btn-img-down{
  padding: 0 10px;
  color: #0e5ac7;
  cursor:default
}
.label-m{
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.size-list{

  width: 97%;
  margin: auto 1% auto 2%;
  padding: 1%;
}
.flex-item {
  width: 33%;
  max-width: 33%;
  min-width: 33%;
  border: 1px solid #A0CFFF;
  box-sizing: border-box;
  padding: 1%;
  margin-right: 0.3%;
  margin-bottom: 5px;
  border-radius: 5px;
  background: #efefef;
}
.btn-del-area{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>







// WEBPACK FOOTER //
// src/views/product/list.vue